import dispatcher from '../dispatcher/dispatcher.js';

export function addNotification(notification){
    dispatcher.dispatch({
        type: 'ADD_NOTIFICATION',
        object: notification
    });/*  */
}


// WEBPACK FOOTER //
// ./src/action/notificationAction.js